export default {
  chapters: 'Глави',
  bookmarks: 'Замітки',
  highlights: 'Нотатки',
  bookInfo: 'Інформація про книгу',
  author: 'Автор',
  title: 'Назва',
  page: 'Сторінка',
  pages: 'сторінок',
  chaptersTitle: 'Зміст',
  bookInfoTitle: 'Інформація про книгу',
  bookmarksTitle: 'Закладки',
  notesTitle: 'Нотатки',
  fileName: 'Назва файлу',
  year: 'Рік',
  format: 'Формат',
  fileSize: 'Розмір файла',
  loadingBook: 'Завантаження книги',
  textSize: 'Розмір тексту',
  textColor: 'Колір фону',
  appearenceTitle: 'Вид',
  viewMode: 'Режим читання',
  addNote: 'Додати замітку',
  editNote: 'Редагувати замітку',
  addBookmark: 'Додати закладку',
  deleteHighlight: 'Видалити виділення',
  default: 'За замовчуванням',
  of: 'з',
  onePage: 'Одна сторінка',
  twoPages: 'Дві сторінки',
  scrolling: 'Прокручування',
  zoom: 'Масштабування',
  found: 'Знайдено',
  searchResults: 'результатів пошуку',
  searchResult: 'результат пошуку',
  searchResultsThanFive: 'результату пошуку',
  notFound: 'Не знайдено',
  errorInfo: 'Виникла помилка.',
  closeReaderBtn: 'Повернутись до бібліотеки ',
  genres: 'Жанри',

  isbn: 'ISBN',
  annotation: 'Анотація',
  authors: 'Автори',
  publisher: 'Видавець',
  series: 'Серії',
  filter: 'Фільтр',
  export: 'Експорт нотаток'
}



// WEBPACK FOOTER //
// ./src/locale/uk-UA/reader.js